// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2DlLo","image":"Header_image__7weoD","name":"Header_name__1MkeW","info":"Header_info__3Zb03","infoRow":"Header_infoRow__J60Av"};